import useScriptData from '../core/hooks/useScriptData'
import {useCallback, useState} from '@wordpress/element'
import useViewport from '../core/hooks/useViewport'
import {BaseProps} from "../types";

export default function EventBlock(props: BaseProps<any[]>) {
  const { data = []} = props
  const [selectedEvent, setSelectedEvent] = useState(0)
  const { isMobile } = useViewport()

  const onMouseEnter = (index: number) => {
    setSelectedEvent(index)
  }

  const onMouseLeave = () => {
    setSelectedEvent(0)
  }

  const renderContent = useCallback(() => {
    return data.map((item: any, index: number) => {
      let className: string
      if (isMobile) {
        className = 'visible'
      } else {
        className = index === selectedEvent ? 'visible' : 'collapse'
      }
      const isLast = index === data.length - 1
      return (
        <div
          key={index}
          className="min-h-[190px] lg:ml-[50%] relative w-full lg:w-1/2 flex flex-col lg:flex-row group"
          onMouseEnter={() => onMouseEnter(index)}
        >
          <div className="flex relative">
            <div className="relative flex flex-col items-center">
              <div className="z-10 pt-0">
                <div className="h-6 w-6 bg-gray-100 group-hover:bg-blue-100 rounded-full shrink-0"></div>
              </div>
              {
                !isLast && (
                  <div className="absolute left-1/2 h-full bg-blue-100 w-[2px] -translate-x-1/2"></div>
                )
              }
            </div>
            <div className="ml-6 pb-7">
              <div
                className="text-primary text-[20px] leading-[27px] lg:text-[36px] lg:font-normal lg:leading-[48px] font-exo mb-[10px]">
                { item.title || item.name }
              </div>
              <div
                className="leading-[22px] text-[16px] lg:text-[20px] text-dimgray inline-block min-h-[88px] mb-3"
                dangerouslySetInnerHTML={{ __html: item.description }}
              >
              </div>
              {
                !isLast ? (
                  <div className={'lg:absolute lg:-top-8 lg:left-0 lg:-translate-x-full ' + className}>
                    <div className="lg:banner-crop-2">
                      <img className="rounded-[10px]" src={item.image || item.image_url} alt={''} />
                    </div>
                  </div>
                ) : (
                  <div className={'lg:absolute lg:bottom-0 lg:left-0 lg:-translate-x-full ' + className }>
                    <div className="lg:banner-crop-3">
                      <img className="rounded-[10px]" src={item.image || item.image_url} />
                    </div>
                  </div>
                )
              }

            </div>
          </div>
        </div>
      )
    })
  }, [data, selectedEvent, isMobile])

  if (!Array.isArray(data)) return null

  return (
    <div className={'relative'} onMouseLeave={onMouseLeave}>
      {renderContent() }
    </div>
  )
}